import { render, staticRenderFns } from "./MaterialDistribution-new.vue?vue&type=template&id=94ce9b78&scoped=true"
import script from "./MaterialDistribution-new.vue?vue&type=script&lang=js"
export * from "./MaterialDistribution-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ce9b78",
  null
  
)

export default component.exports